if (!window.EcoScentNewHeader) {
  window.EcoScentNewHeader = {
    sectionSelector: '.new-header-section',
    hoverCloseDelay: 120,

    positionMegaWrap: function (header, megaWrap) {
      if (!header || !megaWrap) return;
      megaWrap.style.top = header.getBoundingClientRect().bottom + 'px';
    },

    closeAllNavigationItems: function (header) {
      header.querySelectorAll('.new-header-nav-item').forEach(function (item) {
        item.classList.remove('is-open');
      });
    },

    initMegaMenu: function (header, root) {
      const namespace = window.EcoScentNewHeader;
      const megaWrap = root.querySelector('.new-header-mega-wrap');
      let openPanel = null;
      let closeTimer = null;

      const reposition = function () {
        namespace.positionMegaWrap(header, megaWrap);
      };

      const openPanelFor = function (panel, navigationItem) {
        if (openPanel && openPanel !== panel) {
          openPanel.classList.remove('is-open');
          namespace.closeAllNavigationItems(header);
        }
        if (!panel) return;

        reposition();
        panel.classList.add('is-open');
        navigationItem.classList.add('is-open');
        openPanel = panel;
      };

      const closePanel = function () {
        if (openPanel) openPanel.classList.remove('is-open');
        namespace.closeAllNavigationItems(header);
        openPanel = null;
      };

      const scheduleClose = function () {
        closeTimer = window.setTimeout(closePanel, namespace.hoverCloseDelay);
      };

      const cancelClose = function () {
        window.clearTimeout(closeTimer);
      };

      header.querySelectorAll('.new-header-nav-item[data-mega-id]').forEach(function (navigationItem) {
        const panelId = navigationItem.getAttribute('data-mega-id');
        const panel = panelId ? document.getElementById(panelId) : null;

        navigationItem.addEventListener('mouseenter', function () {
          cancelClose();
          openPanelFor(panel, navigationItem);
        });
        navigationItem.addEventListener('mouseleave', scheduleClose);

        if (panel) {
          panel.addEventListener('mouseenter', cancelClose);
          panel.addEventListener('mouseleave', scheduleClose);
        }
      });

      window.addEventListener('scroll', reposition, { passive: true });
      window.addEventListener('resize', reposition, { passive: true });
      reposition();
    },

    initDrawer: function (root) {
      const drawer = root.querySelector('.new-header-drawer');
      const overlay = root.querySelector('.new-header-drawer-overlay');
      const hamburger = root.querySelector('.new-header-hamburger');
      const closeButton = root.querySelector('.new-header-drawer-close');

      const openDrawer = function () {
        if (drawer) {
          drawer.classList.add('is-open');
          drawer.removeAttribute('aria-hidden');
        }
        if (overlay) overlay.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      };

      const closeDrawer = function () {
        if (drawer) {
          drawer.classList.remove('is-open');
          drawer.setAttribute('aria-hidden', 'true');
          drawer.querySelectorAll('.new-header-drawer-sub.is-open').forEach(function (submenu) {
            submenu.classList.remove('is-open');
          });
        }
        if (overlay) overlay.classList.remove('is-open');
        document.body.style.overflow = '';
      };

      if (hamburger) hamburger.addEventListener('click', openDrawer);
      if (closeButton) closeButton.addEventListener('click', closeDrawer);
      if (overlay) overlay.addEventListener('click', closeDrawer);
      if (!drawer) return;

      drawer.querySelectorAll('[data-new-header-open-submenu]').forEach(function (button) {
        button.addEventListener('click', function () {
          const submenu = document.getElementById(button.getAttribute('data-new-header-open-submenu'));
          if (submenu) submenu.classList.add('is-open');
        });
      });

      drawer.querySelectorAll('.new-header-drawer-back').forEach(function (button) {
        button.addEventListener('click', function () {
          const submenu = button.closest('.new-header-drawer-sub');
          if (submenu) submenu.classList.remove('is-open');
        });
      });

      drawer.querySelectorAll('.new-header-drawer-accordion-header').forEach(function (button) {
        button.addEventListener('click', function () {
          button.closest('.new-header-drawer-accordion-item').classList.toggle('is-open');
        });
      });
    },

    initSection: function (header) {
      const namespace = window.EcoScentNewHeader;
      if (header.dataset.newHeaderReady === 'true') return;
      header.dataset.newHeaderReady = 'true';

      const root = header.parentElement || document;
      namespace.initMegaMenu(header, root);
      namespace.initDrawer(root);
    },

    initAllSections: function (root) {
      const namespace = window.EcoScentNewHeader;
      const scope = root || document;
      scope.querySelectorAll(namespace.sectionSelector).forEach(namespace.initSection);
    },

    handleSectionLoad: function (event) {
      window.EcoScentNewHeader.initAllSections(event.target);
    },

    listen: function () {
      const namespace = window.EcoScentNewHeader;

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
          namespace.initAllSections();
        });
      } else {
        namespace.initAllSections();
      }

      document.addEventListener('shopify:section:load', namespace.handleSectionLoad);
    },
  };

  window.EcoScentNewHeader.listen();
}
